import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import { Dropdown, Tab, ButtonGroup, DropdownButton } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { json } from "stream/consumers";
import clsx from 'clsx';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from "../../../common/Toastr";
import ExpenseSheet from "../expenseSheet/ExpenseSheet";
import ExpenseEntryForm from "./ExpenseEntryForm";
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ExpensePerdiem from "./ExpensePerdiem";
import ExpenseSheetPrintForm from "./ExpenseSheetPrintForm";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import ExpenseEntriesNavbar from "../ExpenseEntriesNavbar";
import ExpenseEntryOffCanvas from '../../../common/OffCanvas';
import {
    resetSelectedRecordObjectInState, getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync,
    getCalculateAmountAndReimburseAsync, ShowExpenseSheetStatusAsync, checkedAllEntryState, unCheckedAllEntryState, checkedEntryState,
    unCheckedEntryState, getExpenseSheetTotalAmountAsync, getDataByAccountExpenseEntryIdAsync, deleteAccountExpenseEntryAsync,
    deleteAllSelectedExpenseEntriesAsync, updateAccountExpenseSheetAsync, SubmitExpenseSheetAsync, GetEmployeeExpenseSheetApprovalDetailAsync,
    GetSubmittedByAndSubmittedOnAsync, getValidateAccountExpensePolicyAsync, updateAccountExpenseEntryId,
    getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync, updatePagination
} from '../expenseSlice';
import { resetAttachmentList } from '../../../features/attachment/AttachmentSlice';
import moment from "moment";
import ExpenseSheetApprovalDetail from "../ExpenseSheetApprovalDetail";
import { AttachmentUpload } from '../../attachment/AttachmentUpload'
import { addAttachment } from '../../attachment/AttachmentSlice';
import GetAttachments from '../../attachment/AttachmentItem';
import Loader from "../../../common/Loader";
import { useTranslation } from "react-i18next";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { formatDateWithDateAndMonthName, getFilteredList, sortData, getValueFromResource, FormatInvoiceDecimalNumber } from "../../../common/timeLiveFunction";
import PageSizeSelect from "../../../common/PageSizeSelect";

const itemClass = 'ms-1 ms-lg-0';

const initialSortValues = {
    sortOrder: 'asc',
    sortColumn: 'Amount'
}

const ExpenseEntries = (props: any) => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const modelRefApproval = useRef<any>(null);
    const modelRefPerDiem = useRef<any>(null);
    const location = useLocation();
    const { obj } = location.state || {};
    const { t } = useTranslation();
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
    // const [hoveredColumn, setHoveredColumn] = useState(null);

    // const AccountEmployeeExpenseSheetId = params.get('AccountEmployeeExpenseSheetId');   
    const { cultureInfoName, decimalPlaces, pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, sessionAccountEmployeeId, enableUploadFeature } = useAppSelector((state) => state.globalState);
    const { isReload, employeeList, MasterEmployeeExpenseSheetId, AccountEmployeeId, expensesheetDate,
        accountCurrencyId, expenseSheetDescription, selectedRecord, expenseEntryList, filteredExpenseEntryList,
        expenseSheetApprovalList, pageSize, currentPage, IsValidatePerDiemPolicy, reimburseCurrencyId, AccountExpenseEntryId,
        isLoading, LockSubmittedRecord, LockApprovedRecord, DecimalPlaces, ReimburseCurrency,SheetSubmitted,SheetApproved } = useAppSelector((state) => state.expense);
        let AccountEmployeeExpenseSheetId = '00000000-0000-0000-0000-000000000000';
    // let AccountEmployeeExpenseSheetId = '';
    if (MasterEmployeeExpenseSheetId && MasterEmployeeExpenseSheetId !== '') {
        AccountEmployeeExpenseSheetId = MasterEmployeeExpenseSheetId;
    } else if (obj && obj.AccountEmployeeExpenseSheetId) {
        AccountEmployeeExpenseSheetId = obj.AccountEmployeeExpenseSheetId;
    }
    const currentDate = new Date();
    const [showModal, setShowModal] = useState(false);

    //Attachment Work
    const modalAttachmentRef = useRef<any>(null);
    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const attachmentUploadClearRef = useRef<any>(null);

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    useEffect(() => {
        if (modalIsOpen) {
            if (modalAttachmentRef.current) {
                modalAttachmentRef.current.click();
            }
        }
    }, [modalIsOpen]);
    const handleAttachment = () => {
        dispatch(resetAttachmentList());
        setModalIsOpen(true);
    }
    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    };
    //Attachment Work


    useEffect(() => {
        dispatch(getValidateAccountExpensePolicyAsync(AccountEmployeeId));
        if (isReload) {
            if (AccountEmployeeExpenseSheetId && AccountEmployeeExpenseSheetId !== '00000000-0000-0000-0000-000000000000') {
                dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId));
            }
        }
    }, [isReload])

    useEffect(() => {
        if (AccountEmployeeExpenseSheetId && AccountEmployeeExpenseSheetId !== '00000000-0000-0000-0000-000000000000') {
            dispatch(getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId));
            dispatch(GetEmployeeExpenseSheetApprovalDetailAsync(AccountEmployeeExpenseSheetId));
            dispatch(GetSubmittedByAndSubmittedOnAsync(AccountEmployeeExpenseSheetId))
                .unwrap()
                .then((originalPromiseResult) => {
                    const submittedDate = originalPromiseResult.Data[0].SubmittedDate;
                    const formattedDate: any = submittedDate ? moment(submittedDate).format('M-D-YYYY') : null;
                })
                .catch((rejectedValueOrSerializedError) => {

                })
        }
    }, [AccountEmployeeExpenseSheetId]);

    const checkAndHandleOffCanvas = (id: number) => {
        dispatch(updateAccountExpenseEntryId(id));
        onEditClick(id);
    };

    const filteredData: any = getFilteredList(expenseEntryList, '');
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    //const currentItems = expenseEntryList.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, clientSideSorting.sortOrder, clientSideSorting.sortColumn).slice(indexOfFirstItem, indexOfLastItem);

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedEntryState(rowId))
        } else {
            dispatch(unCheckedEntryState(rowId))
        }
    };
    const onDeleteClick = (AccountExpenseEntryId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountExpenseEntryAsync(AccountExpenseEntryId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast('Success', originalPromiseResult.ResponseMessage, "success", "toast-top-right") :
                                ShowToast('Error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            console.log('onDeleteClick-deleteAccountExpenseEntryAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }
    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllEntryState());
        } else {
            dispatch(unCheckedAllEntryState());
        }
    };

    const onDeleteSelectedClick = () => {
        let tempDeletedArray: any[] = [];
        expenseEntryList.map((item: any) => {
            if (item.isSelected == 1) {
                tempDeletedArray.push(item.AccountExpenseEntryId)
            }
        })
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllSelectedExpenseEntriesAsync(tempDeletedArray.toString()))
                        .unwrap()
                        .then((result) => {
                            result.StatusCode === "200" ?
                                ShowToast('Success', result.ResponseMessage, "success", "toast-top-right") :
                                ShowToast('Error', result.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((error) => {
                        })
                }
            })
            .catch((error) => {
            });
    }
    const onEditClick = (AccountExpenseEntryId: any) => {
        dispatch(updateAccountExpenseEntryId(AccountExpenseEntryId));
        dispatch(getDataByAccountExpenseEntryIdAsync(AccountExpenseEntryId))
            .unwrap()
            .then((originalPromiseResult) => {

            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('getDataByAccountExpenseEntryIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const renderStatusExpenseEntries = (selectedRow: any) => {
        let status: any = "";
        if (selectedRow.ApprovalStatus == "Submitted" || selectedRow.ApprovalStatus == "Pending Approval") {
            status = (
                <span className="badge badge-light-primary fs-7">
                  {/* {t('Submitted')} */}
                  {getValueFromResource('Submitted',dispatch, t)}
                </span>
            )
        }
        else if (selectedRow.ApprovalStatus == "Approved") {
            status = (
                <span className="badge badge-light-success fs-7">
                 {/* {t('Approved')} */}
                 {getValueFromResource('Approved',dispatch, t)}
                </span>
            )
        }
        else if (selectedRow.ApprovalStatus == "Rejected") {
            status = (
                <span className="badge badge-light-danger fs-7">            
                    {/* {t('Rejected')} */}
                    {getValueFromResource('Rejected',dispatch, t)}
                </span>
            )
        }
        else {
            status = (
                <span className="badge badge-light-warning fs-7">                  
                    {/* {t('Not Submitted')} */}
                    {getValueFromResource('Not Submitted',dispatch, t)}
                </span>
            )

        }
        return status;
    }

    const onEditPerdiemClick = (id: number, LocationId: any) => {

        dispatch(updateAccountExpenseEntryId(id));
        onEditClick(id);
    };


    const ExpenseSheetObject = {
        "SheetEmployeeId": AccountEmployeeId,
        "SheetDate": new Date(),
        "SheetReimburseCurrency": 0,
        "SheetDescription": (moment(new Date()).format('MM-DD-YYYY')),
    }

    const generalObject1 = {
        "name": (Object.keys(selectedRecord).length > 0 ? 
        // t('Update')
        getValueFromResource('Update ',dispatch, t) : 
        //  t('Add'))
        getValueFromResource('Add ',dispatch, t)) 
          + ' ' +
        //    t('Expense Entry'),
        getValueFromResource('Expense Entry',dispatch, t),

        "width": "700px",
        "componentName": <ExpenseEntryForm />
    }

    const handleAudit = (AccountExpenseEntryId: any) => {
        const obj = {
            Id: AccountExpenseEntryId,
            TableName: 'AccountExpenseEntry',
            Title: getValueFromResource('Expense Entry Audit', dispatch, t)
        }
        // navigate('/accountaudit', { state: { obj } });
        navigate(`/accountaudit/${AccountExpenseEntryId}`, { state: { obj } })

    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        setClientSideSorting({
            ...clientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn
        });
        dispatch(updatePagination({
            "pageSize": pageSize,
            "currentPage": 1
        }));
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    return (
        <>
            {isLoading && <Loader />}
            {modalIsOpen && (
                <>
                    <div className="modal drawer-overlay" tabIndex={-1} id="attachmentModel" data-bs-backdrop="false">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content rounded">
                                <div className='modal-header pb-2'>
                                    <h6>
                                        {/* {t(`Attachment`)} */}
                                        {getValueFromResource('Attachment',dispatch, t)}
                                        </h6>
                                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => setModalIsOpen(false)}>
                                        <KTIcon iconName='cross' className='fs-1' />
                                    </div>
                                </div>
                                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                    <AttachmentUpload
                                        Id={AccountExpenseEntryId}
                                        onupdateTempAttachmentId={updateTempAttachmentId}
                                        clearRef={attachmentUploadClearRef}
                                        AccountAttachmentTypeId={1}
                                    />
                                    <GetAttachments Id={AccountExpenseEntryId} AccountAttachmentTypeId={1} IsShowEmployeeInformation={false} />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        data-bs-dismiss="modal"
                                        onClick={() => setModalIsOpen(false)}
                                    >
                                        {/* {t("Cancel")} */}
                                        {/* {getValueFromResource('Cancel',dispatch, t)} */}
                                         {getValueFromResource('Close',dispatch, t)}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button ref={modalAttachmentRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attachmentModel">
                        {/* Launch demo modal */}
                        {getValueFromResource(' Launch demo modal',dispatch, t)}
                    </button>
                </>
            )}


            <ExpenseEntriesNavbar />
            <div className="card card-custom admin-card" style={{ marginTop: '-15px' }}>
                <div className="card-header">
                    <h3 className="card-title fw-bold headerTitle" style={{ marginLeft: '-20px', marginBottom: '-15px' }}>
                        {/* {t('Expense Entry List')} */}
                        {getValueFromResource('Expense Entry List',dispatch, t)}
                        </h3>
                    <div className="card-toolbar">

                        <div className="fw-bold me-5" style={{ marginRight: '2px', display: expenseEntryList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                            <span className="me-2" data-kt-user-table-select="selected_count">{expenseEntryList.filter((item: any) => item.isSelected === 1).length}</span>
                             {/* Selected */}
                             {getValueFromResource('Selected',dispatch, t)}
                        </div>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                            style={{ marginRight: '2px', display: expenseEntryList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                        >
                            {/* {t('Delete')} */}
                            {getValueFromResource('Delete',dispatch, t)}
                        </button>
                    </div>
                </div>
                <div className='card-body py-3'>
                    <div className='table-responsive'>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                            <thead>
                                <tr className="thHeading align-middle " >
                                    {IsDelete &&
                                        <th className='w-25px'>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    checked={expenseEntryList.every((item: any) => item.isSelected === 0) ? false :
                                                        (expenseEntryList.every((item: any) => item.isSelected === 1 ? true : false))
                                                    }
                                                    onChange={handleSelectAllChange}
                                                />
                                            </div>
                                        </th>
                                    }
                                    <th
                                        // className='w-15'
                                        style={{ width: '15%' }}
                                    // onMouseEnter={() => handleMouseEnter(0)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t('Expense Details')} */}
                                        {getValueFromResource('Expense Details',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'AccountExpenseEntryDate' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseEntryDate") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseEntryDate") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 0 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountExpenseEntryDate") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountExpenseEntryDate") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th
                                        //className='w-15'
                                        style={{ width: '25%' }}
                                    // onMouseEnter={() => handleMouseEnter(1)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t('Project Name')} */}
                                        {getValueFromResource('Project Name',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'ProjectName' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 1 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ProjectName") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ProjectName") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th
                                        //className='w-15' 
                                        style={{ width: '15%', textAlign: 'right', paddingRight: '15px' }}
                                    // onMouseEnter={() => handleMouseEnter(2)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t('Amount')} */}
                                        {getValueFromResource('Amount',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'Amount' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 2 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Amount") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Amount") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th
                                        //className='w-25' 
                                        style={{ width: '25%', textAlign: 'left', paddingLeft: '15px' }}
                                    // onMouseEnter={() => handleMouseEnter(3)}
                                    // onMouseLeave={handleMouseLeave}
                                    >
                                        {/* {t('Description')} */}
                                        {getValueFromResource('Description',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'Description' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "Description") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "Description") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 3 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "Description") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "Description") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th
                                        //className='w-15 text-center'
                                        style={{ width: '15%' }}
                                    >
                                        {/* {t('Status')} */}
                                        {getValueFromResource('Status',dispatch, t)}
                                        {clientSideSorting.sortColumn === 'ApprovalStatus' ?
                                            clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ApprovalStatus") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ApprovalStatus") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            // hoveredColumn === 3 && 
                                            <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ApprovalStatus") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ApprovalStatus") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                            </>}
                                    </th>
                                    <th className='w-10 text-center'></th>
                                </tr>
                            </thead>
                            <tbody>

                                {currentItems.length > 0 && currentItems.map((expenseEntryDetail: any, i: any) => (
                                    <tr key={i}>
                                        {IsDelete &&
                                            <td>
                                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input widget-9-check"
                                                        checked={expenseEntryDetail.isSelected == 0 ? false : true}
                                                        onChange={(e) => { handleCheckboxChange(e, expenseEntryDetail.AccountExpenseEntryId) }}
                                                    />
                                                </div>
                                            </td>
                                        }
                                        <td>
                                            <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                {/* {moment.parseZone(expenseEntryDetail.AccountExpenseEntryDate).format('DD MMM yy')} */}
                                                {formatDateWithDateAndMonthName(expenseEntryDetail.AccountExpenseEntryDate, cultureInfoName.toString())}
                                            </span>
                                            <br />
                                            {expenseEntryDetail.AccountExpensePolicyPerDiemLocationId ? (
                                                <a
                                                    id="btnAddPerDiem"
                                                    style={{ cursor: 'pointer' }}
                                                    ref={modelRef}
                                                    data-bs-toggle={IsEdit && (!expenseEntryDetail.Submitted || !LockSubmittedRecord) && (!expenseEntryDetail.Approved || !LockApprovedRecord) ? 'modal' : ''}
                                                    data-bs-target={IsEdit && (!expenseEntryDetail.Submitted || !LockSubmittedRecord) && (!expenseEntryDetail.Approved || !LockApprovedRecord) ? '#perDiemModal' : ''}
                                                    onClick={IsEdit && (!expenseEntryDetail.Submitted || !LockSubmittedRecord) && (!expenseEntryDetail.Approved || !LockApprovedRecord) ? () => onEditPerdiemClick(expenseEntryDetail.AccountExpenseEntryId, expenseEntryDetail.AccountExpensePolicyPerDiemLocationId) : undefined}
                                                >
                                                    <span className="fw-bold fs-7">
                                                        {expenseEntryDetail.AccountExpenseName}
                                                    </span>
                                                    <span className="fw-bold fs-7 text-success">
                                                        {expenseEntryDetail.PerDiemLocationName ? getValueFromResource('(Per Diem)', dispatch, t) : ''}
                                                    </span>
                                                </a>
                                            ) : (
                                                <a
                                                    id={IsEdit && (!expenseEntryDetail.Submitted || !LockSubmittedRecord) && (!expenseEntryDetail.Approved || !LockApprovedRecord) ? "kt_OffCanvas" : ''}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={IsEdit && (!expenseEntryDetail.Submitted || !LockSubmittedRecord) && (!expenseEntryDetail.Approved || !LockApprovedRecord) ? () => checkAndHandleOffCanvas(expenseEntryDetail.AccountExpenseEntryId) : undefined}
                                                >
                                                    <span className="fw-bold fs-7">
                                                        {expenseEntryDetail.AccountExpenseName}
                                                    </span>
                                                </a>
                                            )}
                                        </td>

                                        <td>
                                            <span className="fs-7"> {expenseEntryDetail.ProjectName}</span>
                                        </td>
                                        <td style={{ textAlign: 'right', paddingRight: '15px' }}>
                                            {/* <span className="fs-7">{expenseEntryDetail.CurrencyCode}  {parseFloat(expenseEntryDetail.Amount).toFixed(DecimalPlaces)}</span> */}
                                            <span className="fs-7">{expenseEntryDetail.CurrencyCode}  {FormatInvoiceDecimalNumber(cultureInfoName.toString(), expenseEntryDetail.Amount, decimalPlaces)}</span> <br />                                           
                                            {expenseEntryDetail.PerDiemLocationName && (
                                                <label
                                                    style={{
                                                        border: "1px solid #dadfe3",
                                                        borderRadius: "3px",
                                                        background: expenseEntryDetail.PerDiemLocationName.trim().length > 1 ? "#e1e5ec" : "#ccc", // Change background color based on text length
                                                        color: '#7b8ba6',
                                                        padding: "3px",
                                                        fontSize: "9px",
                                                        fontWeight: "600",
                                                        display: 'inline-block',
                                                    }}
                                                >
                                                    {expenseEntryDetail.PerDiemLocationName.trim()}
                                                </label>
                                            )}
                                        </td>

                                        <td style={{ textAlign: 'left', paddingLeft: '15px' }}>
                                            <span className="fs-7">  {expenseEntryDetail.Description} </span>
                                        </td>

                                        <td >
                                            {renderStatusExpenseEntries(expenseEntryDetail)}
                                        </td>

                                        <td className='text-center'>
                                            <Dropdown
                                                style={{ marginLeft: 1 }}
                                                className={clsx('cursor-pointer symbol')}
                                                data-kt-menu-attach='parent'
                                                data-kt-menu-placement='bottom-end'
                                            >
                                                <Dropdown.Toggle
                                                    variant="transparent"
                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                    data-tooltip-id="tooltip-Description"
                                                    data-tooltip-content=
                                                    // {t("More")}
                                                    {getValueFromResource('More',dispatch, t)}
                                                    data-tooltip-place="top"
                                                >
                                                    <i className="bi bi-three-dots fs-7"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu
                                                    className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                    {IsEdit &&
                                                        <>
                                                            {(
                                                                (!expenseEntryDetail.Submitted || !LockSubmittedRecord) &&
                                                                (!expenseEntryDetail.Approved || !LockApprovedRecord)
                                                            ) && (
                                                                    <>
                                                                        <div className='menu-hover-bg-sec'>
                                                                            {expenseEntryDetail.AccountExpensePolicyPerDiemLocationId ? (
                                                                                <Dropdown.Item
                                                                                    className="menu-item me-lg-0"
                                                                                    id="btnAddPerDiem"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    ref={modelRef}
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#perDiemModal"
                                                                                    onClick={() => onEditPerdiemClick(expenseEntryDetail.AccountExpenseEntryId, expenseEntryDetail.AccountExpensePolicyPerDiemLocationId)}
                                                                                >
                                                                                    <span className="menu-icon custom-menu">
                                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                                            <span className="path1"></span>
                                                                                            <span className="path2"></span>
                                                                                        </i>
                                                                                    </span>
                                                                                    <span className="menu-title custom-menu-fontsize">
                                                                                        {/* {`${t('Edit Expense')}`} */}
                                                                                        {getValueFromResource('Edit Expense',dispatch, t)}
                                                                                        </span>
                                                                                </Dropdown.Item>
                                                                            ) : (
                                                                                <Dropdown.Item
                                                                                    className="menu-item me-lg-0"
                                                                                    id="kt_OffCanvas"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => checkAndHandleOffCanvas(expenseEntryDetail.AccountExpenseEntryId)}
                                                                                >
                                                                                    <span className="menu-icon custom-menu">
                                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                                            <span className="path1"></span>
                                                                                            <span className="path2"></span>
                                                                                        </i>
                                                                                    </span>
                                                                                    <span className="menu-title custom-menu-fontsize">
                                                                                        {/* {`${t('Edit Expense')}`} */}
                                                                                        {getValueFromResource('Edit Expense',dispatch, t)}
                                                                                        </span>
                                                                                </Dropdown.Item>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                        </>
                                                    }
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => handleAudit(expenseEntryDetail.AccountExpenseEntryId)}
                                                        >
                                                            <span className="menu-icon custom-menu mb-2">
                                                                <i className="bi bi-receipt fs-6 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Audit')}`} */}
                                                                {getValueFromResource('Audit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                {enableUploadFeature &&
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={(event: any) => {
                                                                event.preventDefault();
                                                                dispatch(updateAccountExpenseEntryId(expenseEntryDetail.AccountExpenseEntryId));
                                                                handleAttachment();
                                                            }}
                                                        >
                                                            <span className="menu-icon custom-menu mb-2" style={{ marginLeft: '-3px' }}>
                                                                <i className="bi bi-paperclip fs-4 iconColor">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize" style={{ marginLeft: '-3px' }}>
                                                                {/* {`${t('View Attachment')}`} */}
                                                                {getValueFromResource('View Attachment',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                    }
                                                    {IsDelete &&
                                                        <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                    }
                                                    {IsDelete && !((SheetSubmitted && LockSubmittedRecord) || (SheetApproved && LockApprovedRecord)) && 
                                                        <>
                                                            <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onDeleteClick(expenseEntryDetail.AccountExpenseEntryId) }}>
                                                                    <span className="menu-icon  custom-menu">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title delete-menu custom-menu-fontsize"  >
                                                                        {/* {`${t('Delete')}`} */}
                                                                        {getValueFromResource('Delete',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {expenseEntryList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <ExpenseSheetPrintForm modelRef={modelRef} />
            <ExpenseSheetApprovalDetail modelRef={modelRefApproval} />
            <ExpensePerdiem showModal={showModal} modelRefPerDiem={modelRefPerDiem} />
            <button ref={modelRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#expenseSheetModal">
                {/* Launch demo modal */}
                {getValueFromResource('Launch demo modal',dispatch, t)}
            </button>
            <button ref={modelRefPerDiem} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#perDiemModal">
                {/* Launch demo modal */}
                {getValueFromResource('Launch demo modal',dispatch, t)}
            </button>

            {!showModal &&
                <ExpenseEntryOffCanvas obj={generalObject1} />
            }
        </>


    )

}
const cellStyle = {
    border: '1px Grey',
    fontWeight: 'bold',
};

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default ExpenseEntries;